import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LWBPeriscopeState } from './periscope.state';

export const LWBPeriscopeActions = createActionGroup({
  source: 'LWB Periscope',
  events: {
    Reset: emptyProps(),
    Update: props<{ data: LWBPeriscopeState }>()
  }
});
